export const RefundType = {
  FullRefund: 'FullRefund',
  PartialRefund: 'PartialRefund',
} as const

export interface RefundTransactionFormValues {
  refundType: 'FullRefund' | 'PartialRefund'
  amount: string
}
